import React from 'react'
import _ from 'lodash'
import {
  Col,
  FormInput,
  FormInputCheckbox,
  FormInputDate,
  FormInputSelect,
  FormInputText,
  FormInputTextArea,
  Row
} from 'camino-react'
import CreatableSelect from 'react-select/lib/Creatable'

export default function EditableFormInputFields ({
  valueProps,
  datetimeProps,
  textareaProps,
  checkboxProps,
  selectBoxValueProps,
  creatableBoxValueProps,
  selectBoxProps,
  creatableBoxProps,
  serviceGroups,
  hasManagedServiceGroup,
  ticketStatusInheritParentFields,
  isForTicket,
  taskId,
  contactName,
  fields,
  statusesRootIds,
  ticketTypeId
}) {
  return (
    <React.Fragment>
      <Row smallGutters classExtra="row--bottom-spaced">
        <Col width={12}>
          <FormInput label="Start time">
            <FormInputDate
              enableTime
              {...valueProps('start_time')}
              {...datetimeProps('start_time')}
            />
          </FormInput>
        </Col>
        <Col width={12}>
          <FormInput label="End time">
            <FormInputDate
              enableTime
              {...valueProps('end_time')}
              {...datetimeProps('end_time')}
            />
          </FormInput>
        </Col>
      </Row>
      <Row classExtra="row--bottom-spaced">
        <Col>
          <FormInput label="Description">
            <FormInputTextArea
              {...valueProps('description')}
              {...textareaProps('description')}
            />
          </FormInput>
        </Col>
      </Row>
      <Row classExtra="row--bottom-spaced">
        <Col>
          <FormInput label="Internal comments (optional)">
            <FormInputTextArea
              {...valueProps('comments')}
              {...textareaProps('comments')}
            />
          </FormInput>
        </Col>
      </Row>
      <Row classExtra="row--bottom-spaced">
        {!hasManagedServiceGroup && (
          <Col>
            <FormInput label="Chargeable?">
              <FormInputCheckbox
                {...valueProps('chargeable')}
                {...checkboxProps('chargeable')}
              />
            </FormInput>
          </Col>
        )}
        {taskId && (
          <Col>
            <FormInput label="Complete task?">
              <FormInputCheckbox
                {...valueProps('complete_task')}
                {...checkboxProps('complete_task')}
              />
            </FormInput>
          </Col>
        )}
      </Row>
      {isForTicket && (
        <>
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInput label="Send notes as email">
                <FormInputCheckbox
                  {...valueProps('send_notes')}
                  {...checkboxProps('send_notes')}
                />
              </FormInput>
            </Col>
            <Col>
              {fields.send_notes && (
                <>
                  <FormInput label={`Client contact: ${contactName}`}>
                    <FormInputCheckbox
                      {...valueProps('send_to_contact')}
                      {...checkboxProps('send_to_contact')}
                    />
                  </FormInput>
                </>
              )}
            </Col>
          </Row>
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInput label="CC">
                <CreatableSelect
                  id="send_notes_cc"
                  disabled={!fields.send_notes}
                  {...creatableBoxValueProps('notes_cc')}
                  {...creatableBoxProps('notes_cc')}
                  multi
                />
              </FormInput>
            </Col>
          </Row>
        </>
      )}
      {!_.isEmpty(serviceGroups) && (
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="Managed Service Contract">
              <FormInputSelect
                id="service_group_id_field"
                {...selectBoxValueProps('service_group_id')}
                {...selectBoxProps('service_group_id')}
              />
            </FormInput>
          </Col>
        </Row>
      )}
      <Row smallGutters classExtra="row--bottom-spaced">
        <Col width={12}>
          <FormInput label="Work Role">
            <FormInputSelect
              id="work_role_select_field"
              {...selectBoxValueProps('work_role_id')}
              {...selectBoxProps('work_role_id')}
            />
          </FormInput>
        </Col>
        <Col width={12}>
          <FormInput label="Work Type">
            <FormInputSelect
              id="work_type_select_field"
              {...selectBoxValueProps('work_type_id')}
              {...selectBoxProps('work_type_id')}
            />
          </FormInput>
        </Col>
      </Row>
      <Row classExtra="row--bottom-spaced">
        <Col>
          <FormInput label="Utilization deductable minutes">
            <FormInputText
              {...valueProps('utilization_deductable_minutes')}
              {...textareaProps('utilization_deductable_minutes')}
            />
          </FormInput>
        </Col>
      </Row>
      {isForTicket && (
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="Ticket Status">
              <FormInputSelect
                id="ticket_status_select_field"
                {...selectBoxValueProps('ticket_status_id')}
                {...selectBoxProps('ticket_status_id')}
              />
            </FormInput>
          </Col>
        </Row>
      )}
      {ticketStatusInheritParentFields(_.get(statusesRootIds, 'onHoldRootId')) && isForTicket && (
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="When will this ticket re-open?">
              <FormInputDate
                enableTime={false}
                {...valueProps('ticket_reopen_on')}
                {...datetimeProps('ticket_reopen_on')}
              />
            </FormInput>
          </Col>
          <Col>
            <FormInput label="Why is this ticket being put on hold?">
              <FormInputText
                {...valueProps('ticket_on_hold_description')}
                {...textareaProps('ticket_on_hold_description')}
              />
            </FormInput>
          </Col>
        </Row>
      )}
      {ticketStatusInheritParentFields(_.get(statusesRootIds, 'resolvedRootId')) && isForTicket && ticketTypeId !== 2 && (
        <>
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInput label="What was the root cause?">
                <FormInputText
                  {...valueProps('ticket_root_cause')}
                  {...textareaProps('ticket_root_cause')}
                />
              </FormInput>
            </Col>
          </Row>
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInput label="What is the preventive action?">
                <FormInputText
                  {...valueProps('ticket_preventive_action')}
                  {...textareaProps('ticket_preventive_action')}
                />
              </FormInput>
            </Col>
          </Row>
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInput label="How did you correct the issue?">
                <FormInputText
                  {...valueProps('ticket_corrective_action')}
                  {...textareaProps('ticket_corrective_action')}
                />
              </FormInput>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}
